import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    // 个人画像 main
    {
      path: '/personalProfile',
      name: 'PersonalProfile',
      component: () => import('./views/PersonalProfile/PersonalProfile.vue'),
    },
    //  分部画像 main
    {
      path: '/divisionProfile',
      name: 'DivisionProfile',
      component: () => import('./views/DivisionProfile/DivisionProfile.vue'),
    },
    // 部门画像 main
    {
      path: '/deptProfile',
      name: 'DeptProfile',
      component: () => import('./views/DeptProfile/DeptProfile.vue'),
    },
    {
      path: '/personalQarList',
      component:() => import ('./views/PersonalProfile/components/QAREvent/QARList'),
      // meta: {
      //   keepAlive: true
      // }
    },
    {
      path: '/stageDetail',
      component: () => import('./views/PersonalProfile/components/StageAnalysis/StageDetail'),
    },
    {
      path: '/personalQarDetail',
      component: () => import('./views/PersonalProfile/components/QAREvent/QARDetail'),
    },
    {
      path: '/personalJobCompetencyDetail',
      component: () => import('./views/PersonalProfile/components/JobCompetency/JobCompetencyDetail')
    },
    {
      path: '/personalWarningHintList',
      component: () => import('./views/PersonalProfile/components/WarningHint/WarningHintList'),
      // meta: {
      //   keepAlive: true
      // }
    },
    {
      path: '/personalWarningHintDetail',
      component: () => import('./views/PersonalProfile/components/WarningHint/WarningHintDetail')
    },
    {
      path: '/branchQarList',
      component:() => import ('./views/DivisionProfile/components/QAREvent/QARList'),
      // meta: {
      //   keepAlive: true
      // }
    },
    {
      path: '/branchQarDetail',
      component: () => import('./views/DivisionProfile/components/QAREvent/QARDetail')
    },
    {
      path: '/branchWarningHintList',
      component: () => import('./views/DivisionProfile/components/WarningHint/WarningHintList'),
      // meta: {
      //   keepAlive: true
      // }
    },
    {
      path: '/branchWarningHintDetail',
      component: () => import('./views/DivisionProfile/components/WarningHint/WarningHintDetail')
    },
    {
      path: '/branchScatterList',
      component: () => import('./views/DivisionProfile/components/Scatter/ScatterList'),
      // meta: {
      //   keepAlive: true
      // }
    },
    {
      path: '/deptQarList',
      component:() => import ('./views/DeptProfile/components/QAREvent/QARList'),
      // meta: {
      //   keepAlive: true
      // }
    },
    {
      path: '/deptQarDetail',
      component: () => import('./views/DeptProfile/components/QAREvent/QARDetail')
    },
    {
      path: '/deptWarningHintList',
      component: () => import('./views/DeptProfile/components/WarningHint/WarningHintList'),
      // meta: {
      //   keepAlive: true
      // }
    },
    {
      path: '/deptWarningHintDetail',
      component: () => import('./views/DeptProfile/components/WarningHint/WarningHintDetail')
    },
    {
      path: '/deptScatterList',
      component: () => import('./views/DeptProfile/components/Scatter/ScatterList'),
      // meta: {
      //   keepAlive: true
      // }
    },
    {
      path: '/fullScreenHeatMap',
      component: () => import('./views/PersonalProfile/components/HeatMap/FullScreenHeatMap')
    }
  ]
})